import { Configuration } from '../data/config';
const imgUrl = {
    //'logo' : require('./covidkayalogo.png'),
    'dohlogo' : require('./dohlogo.png'),
    //'coughing' : require('./coughing.jpg'),
    //'loginPageImage' : require('./loginPageImage.jpg'),
    //'durelogowhite' : require('./durelogowhite.png'),
    'addUser' : require('./home/lightgreen/add-user.svg'),
    'search' : require('./home/lightgreen/search.svg'),
    'alert' : require('./home/lightgreen/alert.svg'),
    'records' : require('./home/lightgreen/records.svg'),
    'referral' : require('./home/lightgreen/referral.svg'),
    'file_download' : require('./home/lightgreen/file-download.svg'),
    'file_upload' : require('./home/lightgreen/file-upload.svg'),
    'chatbot' : require('./newloginpageicons/chatbot.png'),
    'guide' : require('./newloginpageicons/guide.png'),
    'pdf' : require('./newloginpageicons/pdf.png'),
    'video_tutorial' : require('./newloginpageicons/video-tutorial.png'),
    'patientHome' : require('./Patient.png'),
    'prov-home' : require('./Provider.png'),
    'back':require('../images/back.png'),
    'clientImg':require('../images/customer.png'),
    'transferImg':require('../images/transfer.png'),
    'referalImg':require('../images/referral.png'),
    'alertImg':require('../images/bell.png'),
    'treatment':require('../images/calendar.png'),
    'history':require('../images/medical-record.png'),
    'user':require('../images/user.png'),
    'chatbot':require('../images/chatbot.png'),
    //'icon':require('../images/icon.svg'),
    'newprofile':require('../images/user.png'),
    'linelist':require('../images/book.png'),
    // 'who-logo': require('../images/who-logo.png'),
    'client-logo': require('../images/Client.png'),
    'backlogo':require('../images/left-chevron.png'),
    'elearning':require('./../images/elearning.png'),
    'guide':require('../images/guidelines.png'),
    'certify':require('../images/certification.png'),
    'no_plan':require('../images/no_plan.png'),
     'phone_icon':require('../images/newimages/patientdashboard/phone.png'),
     'location_icon':require('../images/newimages/patientdashboard/location.png'),
     'msg_icon' : require('../images/newimages/patientdashboard/msg.png'),
     'scanprofile_icon':require('../images/newimages/patientdashboard/scan-profile.png'),
     'profile_stats':require('../images/newimages/patientdashboard/sdf.png'),
     'maplocate_icon':require('../images/newimages/patientdashboard/map-locate.png'),
     'arrowup_icon':require('../images/newimages/patientdashboard/arrow-up.png'),
     'arrowdown_icon':require('../images/newimages/patientdashboard/arrow-down.png'),
     'lab_one':require('../images/newimages/patientdashboard/Group 442.png'),
     'lab_two':require('../images/newimages/patientdashboard/Group 441.png'),
     'lab_three' : require('../images/newimages/patientdashboard/Group 440.png'),
     'tick_icon':require('../images/newimages/patientdashboard/arrow.png'),
     'pin_icon':require('../images/newimages/patientdashboard/pin.png'),
     'labhsb_icon':require('../images/newimages/patientdashboard/lab_hb.png'),
     'labtri_icon':require('../images/newimages/patientdashboard/lab_tri.png'),
     'labtsh_icon':require('../images/newimages/patientdashboard/lab_tsh.png'),
     'labchol_icon':require('../images/newimages/patientdashboard/lab_chol.png'),
     'camera_icon':require('../images/newimages/patientdashboard/camera-icon.png'),
     'adp_logo':require('../images/newimages/patientdashboard/adalogo.png'),
    'profile_user':require('../images/newimages/female-icon.png'),
    'med_icon':require('../images/newimages/main-dashboard/medicine.png'),
    'calender_icon':require('../images/newimages/main-dashboard/calendar.png'),
    'clock_icon':require("../images/newimages/main-dashboard/clock.png"),
    'missed_icon':require("../images/newimages/main-dashboard/missed.png"),
    'navbarimage': `${Configuration.baseUrl}media/logo.png`,
    'who-logo': `${Configuration.baseUrl}media/logo.png`
}

export default imgUrl;